import React from 'react';

export const Default=()=>{
    return (
        <div className="animated fadeIn">
            Task Plugins of Phoenix v0.51.9
        </div>
    )
}

export default Default;


// WEBPACK FOOTER //
// ./src/views/Default/Default.js